module.exports = __webpack_public_path__ + "img/cleanup9-7-8-2021.9372e6c2.jpg";